var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketsIconEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350.91 240.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 19.97,
    y: 48.12,
    width: 292.39,
    height: 144.27,
    transform: "translate(-30.1 60.65) rotate(-19)",
    style: {
      fill: "#00347f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.25,
    y: 48.72,
    width: 292.39,
    height: 139.32,
    transform: "translate(-4.51 7.92) rotate(-2.26)",
    style: {
      fill: "white",
      stroke: "#00347f",
      strokeMiterlimit: 10,
      strokeWidth: 12
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsIconEmpty);
export default __webpack_public_path__ + "static/media/ticketsIconEmpty.c445e05dea7adc397d3e923798489135.svg";
export { ForwardRef as ReactComponent };